var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PreviewFrame',{attrs:{"accent":_vm.slide.accent},scopedSlots:_vm._u([{key:"presenter",fn:function(){return [_c('div',{staticClass:"hd-stage"},[_c('span',{staticClass:"hd-title"}),_c('span',{staticClass:"hd-subtitle"})])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }